import { render } from "./comboRecipients.vue?vue&type=template&id=6b9ebefa&ts=true"
import script from "./comboRecipients.vue?vue&type=script&lang=ts"
export * from "./comboRecipients.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QItem,QItemSection});qInstall(script, 'directives', {Ripple,ClosePopup});
